import Vue from 'vue'
import VueRouter from 'vue-router'
import Pending from '@/views/Pending.vue'
import History from '@/views/History.vue'
import AccessList from '@/views/AccessList.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: "/",
    redirect: "/nouvelles-demandes"
  },
  {
    path: '/nouvelles-demandes',
    name: 'Nouvelles demandes',
    component: Pending
  },
  {
    path: '/historique',
    name: 'Historiques',
    component: History
  },
  {
    path: '/liste-des-presences',
    name: 'Liste des présences',
    component: AccessList
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
